/**
 * @prettier
 */

document.addEventListener('DOMContentLoaded', () => {
  if ($('[data-widget="editor"]').length) {
    Widget.Editor.init()
  }
})
